import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MasterAdvisorAgreement, MasterAdvisorAgreementDocument } from 'src/app/shared/models/agreement.models';
import { OnboardingTermsOfUse } from 'src/app/shared/models/onboarding.models';
import { OnboardingApiService } from '../http/onboarding-api.service';

@Injectable({
  providedIn: 'root'
})
export class TermsOfUseCompletedResolver implements Resolve<OnboardingTermsOfUse|null> {

  constructor(private onboardingApiService:OnboardingApiService) {
  }

  resolve(route:ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<OnboardingTermsOfUse|null>{
    return this.onboardingApiService.getTermsOfUse().pipe(catchError(() => of(null)));
  }
}